"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsiveCssProps = void 0;
var _styledComponents = require("styled-components");
var _responsive = require("../../helpers/responsive");
var _responsivePropNames = require("./responsivePropNames");
/* eslint-disable @typescript-eslint/no-explicit-any */

const responsiveCssProps = _ref => {
  let {
    props,
    propName,
    cssProperty,
    formatValues,
    joinValues,
    output
  } = _ref;
  const formatValuesFunc = formatValues ? formatValues : v => v;
  const joinValuesFunc = joinValues ? joinValues : values => typeof values === 'object' ? values.map(formatValuesFunc).join(' ') : formatValuesFunc(values);
  const outputFunc = output ? output : (value, cssProperty) => `
    ${cssProperty}: ${value};
  `;
  const outputCss = values => {
    return values !== undefined && values !== null && outputFunc(joinValuesFunc(values), cssProperty);
  };
  const propNames = (0, _responsivePropNames.responsivePropNames)(propName);
  const valueXS = props[propNames[0]];
  const valueS = props[propNames[1]];
  const valueM = props[propNames[2]];
  const valueL = props[propNames[3]];
  const valueXL = props[propNames[4]];
  if (valueXS === undefined && valueS === undefined && valueM === undefined && valueL === undefined && valueXL === undefined) return null;
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], outputCss(valueXS), typeof valueS !== 'undefined' && _responsive.screenMin.s`
      ${outputCss(valueS)}
    `, typeof valueM !== 'undefined' && _responsive.screenMin.m`
      ${outputCss(valueM)}
    `, typeof valueL !== 'undefined' && _responsive.screenMin.l`
      ${outputCss(valueL)}
    `, typeof valueXL !== 'undefined' && _responsive.screenMin.xl`
      ${outputCss(valueXL)}
    `);
};
exports.responsiveCssProps = responsiveCssProps;